/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { mcpRegistriesClearCache } from "../funcs/mcpRegistriesClearCache.js";
import { mcpRegistriesGetServerDetails } from "../funcs/mcpRegistriesGetServerDetails.js";
import { mcpRegistriesGetSetupDocs } from "../funcs/mcpRegistriesGetSetupDocs.js";
import { mcpRegistriesListCatalog } from "../funcs/mcpRegistriesListCatalog.js";
import { mcpRegistriesListRegistries } from "../funcs/mcpRegistriesListRegistries.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ExternalMCPServer } from "../models/components/externalmcpserver.js";
import { GetSetupDocsResponseBody } from "../models/components/getsetupdocsresponsebody.js";
import { ListCatalogResponseBody } from "../models/components/listcatalogresponsebody.js";
import { ListRegistriesResponseBody } from "../models/components/listregistriesresponsebody.js";
import {
  ClearMCPRegistryCacheRequest,
  ClearMCPRegistryCacheSecurity,
} from "../models/operations/clearmcpregistrycache.js";
import {
  GetMCPServerDetailsRequest,
  GetMCPServerDetailsSecurity,
} from "../models/operations/getmcpserverdetails.js";
import {
  GetMCPSetupDocsRequest,
  GetMCPSetupDocsSecurity,
} from "../models/operations/getmcpsetupdocs.js";
import {
  ListMCPCatalogRequest,
  ListMCPCatalogSecurity,
} from "../models/operations/listmcpcatalog.js";
import {
  ListMCPRegistriesRequest,
  ListMCPRegistriesSecurity,
} from "../models/operations/listmcpregistries.js";
import { unwrapAsync } from "../types/fp.js";

export class McpRegistries extends ClientSDK {
  /**
   * clearCache mcpRegistries
   *
   * @remarks
   * Clear the registry cache for a specific registry (admin only)
   */
  async clearCache(
    request: ClearMCPRegistryCacheRequest,
    security?: ClearMCPRegistryCacheSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(mcpRegistriesClearCache(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getServerDetails mcpRegistries
   *
   * @remarks
   * Get detailed information about an MCP server including remotes
   */
  async getServerDetails(
    request: GetMCPServerDetailsRequest,
    security?: GetMCPServerDetailsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ExternalMCPServer> {
    return unwrapAsync(mcpRegistriesGetServerDetails(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getSetupDocs mcpRegistries
   *
   * @remarks
   * Get the published setup documentation for an upstream MCP server, located by endpoint URL and/or registry identifier
   */
  async getSetupDocs(
    request?: GetMCPSetupDocsRequest | undefined,
    security?: GetMCPSetupDocsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetSetupDocsResponseBody> {
    return unwrapAsync(mcpRegistriesGetSetupDocs(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listCatalog mcpRegistries
   *
   * @remarks
   * List available MCP servers from configured registries
   */
  async listCatalog(
    request?: ListMCPCatalogRequest | undefined,
    security?: ListMCPCatalogSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListCatalogResponseBody> {
    return unwrapAsync(mcpRegistriesListCatalog(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRegistries mcpRegistries
   *
   * @remarks
   * List all MCP registries (admin only)
   */
  async listRegistries(
    request?: ListMCPRegistriesRequest | undefined,
    security?: ListMCPRegistriesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRegistriesResponseBody> {
    return unwrapAsync(mcpRegistriesListRegistries(
      this,
      request,
      security,
      options,
    ));
  }
}
